module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-2.6965a58f.png";